module.exports = __webpack_public_path__ + "media/bootstrap-icons/x-diamond-fill-e221bf4b.svg";